﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const operational_context_client_1 = require("@its-suite/operational-context-client");
const __1 = require("..");
class LogoutSaga {
    static *watcher() {
        yield effects_1.takeLatest(__1.SagaActions.SagaTriggerActionTypes.TRIGGER_LOGOUT_SAGA, LogoutSaga.worker);
    }
    static *worker() {
        console.log('LogoutSaga');
        let jwtManager = new operational_context_client_1.JwtManager();
        jwtManager.forget();
        let state = yield effects_1.select();
        yield effects_1.put(__1.SessionModule.actionCreators.afterLogout());
        window.location.assign(`${state.appStaticConfig.BaseUrl}/`);
    }
}
exports.LogoutSaga = LogoutSaga;
//# sourceMappingURL=LogoutSaga.js.map